import { memo } from 'react'
import './index.scss'

/**
 * 空状态
 * @returns
 */
export const Empty = memo(({ title }: { title?: string }) => {
  return (
    <div className="empty-wrap">
      <span className="empty"></span>
      <p className="text">{title ? title : '暂无数据'}</p>
    </div>
  )
})
